import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchAdminDashboard = createAsyncThunk('admin/dashboard', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/admin/dashboard');
    return data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error);
  }
});

export const fetchAnalytics = createAsyncThunk('admin/analytics', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/admin/analytics');
    return data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error);
  }
});

export const fetchViolations = createAsyncThunk('admin/violations', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/admin/violations');
    return data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error);
  }
});

const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    dashboard: null, analytics: null, violations: [], loading: false, error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminDashboard.pending, (state) => { state.loading = true; })
      .addCase(fetchAdminDashboard.fulfilled, (state, action) => {
        state.loading = false; state.dashboard = action.payload;
      })
      .addCase(fetchAdminDashboard.rejected, (state, action) => {
        state.loading = false; state.error = action.payload;
      })
      .addCase(fetchAnalytics.fulfilled, (state, action) => { state.analytics = action.payload; })
      .addCase(fetchViolations.fulfilled, (state, action) => { state.violations = action.payload; });
  },
});

export default adminSlice.reducer;
